<template>

<core-modal v-on:close="onClose">

	<template v-slot:head>

		Add Member

	</template>

	<template v-slot:default>

		<p>Enter the BGG username of the person you would like to add to your group. They do not need to be registered with geekGroup to be added, however they can still later register themselves.</p>

		<core-form-input-textbox :autofocus="true" name="name" v-on:validate="validate" placeholder="Enter BGG username" v-model="inputs.name" :error="is.error" :disabled="is.loading" :validation="validation.name"></core-form-input-textbox>
			
		<div class="notice">It may take some time to add a new member, especially if it's the first time their data is synchronised or the group has a speedboost that needs re-indexing.</div>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading" :disabled="!is.valid">Confirm</core-button>

	</template>

</core-modal>

</template>

<script>

import FormValidation from 'core/mixin/form/Validation.js'

export default {

	mixins: [FormValidation],

	data: function() {

		return {

			is: {
				loading: false,
				syncing: false
			},

			inputs: {
				name: ''
			},

			validation: {
				name: 'exists'
			}

		}

	},

	methods: {

		onConfirmClick: function() {

			if (this.is.valid) {

				this.is.loading = true

				this.$store.dispatch('api/groups/add', {
					user: this.inputs.name,
					name: this.$route.params.name
				}).then(function() {

					window.location.reload()

				}.bind(this), function() {

					this.is.error = true
					this.is.loading = false

				}.bind(this)) 

			}

		},

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.notice {
	padding: 10px;
	border-radius: 4px;
	color: #fff;
	font-size: 16px;
	line-height: 20px;
	background-color: #4881bb;
	font-weight: 400;
}

.notice:after {
	content: '';
    display: block;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 0 16px 16px 16px;
    border-color: transparent transparent #4881bb  transparent;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    position: absolute;
    left: 17px;
    top: -10px;
}

</style>